import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import LoadingComponent from '../components/utility/LoadingComponent';
export const makeAsyncComponent = loader => Loadable({
  delay: 500,
  loader,
  LoadingComponent
});